import React, { useState } from 'react'
import { APILINK } from '../../EndPoint';
import axiosInstance from '../../api/axiosInstance';
import ErrorHandler from "../../error-handler/ErrorHandler"
import { useSelector } from 'react-redux'
import { Select, DatePicker,Button } from "antd"
import { Container, Row, Col, } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const today = new Date();

const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

const Download = ({url ,title}) => {
    const { t } = useTranslation();
    const [banks, setBanks] = useState([]);
    const [selectedBanks, setSelectedBanks] = useState([]);
    const [selectedBanksID, setSelectedBanksID] = useState([]);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const auth = useSelector((state) => state.auth.user.groups)

    const handleBanks = (e) => {
        console.log(e);
        setSelectedBanks(e);
        setSelectedBanksID(e);
    };
    const download = async () => {
        
        let result = await axiosInstance.get(APILINK +
            `/${url}?banks=${selectedBanksID.join(
              ","
            )}&date_from=${dateFrom}&date_to=${dateTo}`,
              {
                  responseType: 'arraybuffer',
                  headers: {
                      'Content-Type': 'text/csv; charset=utf-8',
                  }
              })
                .catch((error) => console.log(error));
      
              if(result) {
                console.log(result)
                  const url = window.URL.createObjectURL(new Blob([result.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `${date} Report.csv`); //or any other extension
                  document.body.appendChild(link);
                  link.click();
              }
      };
    const handleDateFrom = (e, string) => {
        setDateFrom(string);
    };
    const handleDateTo = (e, string) => {
        setDateTo(string);
    };
    const getBanks = async () => {
        let result = await axiosInstance.get(APILINK + `/banks`).catch((err) => {
            console.log(err);
        });
        if (result) {
            console.log(result.data);
            setBanks(result.data);
        }
    };
    return (
        <>
            <Container
                style={{
                    textAlign: localStorage.getItem("lang") == "ar" ? "right" : "left",
                }}
                className="viewSuper align-left"
            >
                <Row>
                    <Col sm="12">
                        <h2>{title}</h2>
                    </Col>
                </Row>
                <Row>
                    {auth === "superuser" ?  <Col sm={6}>
                        <label className="label">{t("branch.bank")}</label>
                        <Select
                            mode="multiple"
                            placeholder="إختر البنوك"
                            value={selectedBanks}
                            onChange={handleBanks}
                            style={{ width: "100%" }}
                            onClick={getBanks}
                        >
                            {banks.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name_en}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col> : null}
                   
                    <Col sm="6">
                        <label className="label">{t("reports.date")}</label>

                        <Col sm={12}>
                            <label className="label">{t("reports.from")}</label>
                            <DatePicker className="w-100" onChange={handleDateFrom} />
                        </Col>
                        <Col sm={12}>
                            <label className="label">{t("reports.to")}</label>
                            <DatePicker className="w-100" onChange={handleDateTo} />
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button className="buttonMargin" onClick={download}>
                            {t("reports.download")}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ErrorHandler(Download, axiosInstance)